import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';



export default {
    computed: {
        ...rootMapState(usePageStore, {
            isSearchCenter: store => store.page.searchCenter
        }),
        ...mapState({
            hasLocation: "hasLocation"
        })
    }
};
